var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _vm.browse != null
        ? _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "7" } },
                    [
                      _c("app-view-list", {
                        attrs: {
                          title: _vm.$ct("views"),
                          views: _vm.browse.Views,
                          "show-share-button": "",
                        },
                        on: {
                          "new-clicked": function ($event) {
                            return _vm.createNewView()
                          },
                          "edit-clicked": function ($event) {
                            return _vm.editClicked($event)
                          },
                          "delete-clicked": function ($event) {
                            return _vm.deleteView($event)
                          },
                        },
                      }),
                      _vm.AuthService().isDevModeEnabled
                        ? _c(
                            "w-card",
                            { staticClass: "vs-root" },
                            [
                              _c("w-card-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "components.view-editor.extensions.title"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "w-card-content",
                                { staticClass: "vs-content" },
                                [
                                  _c("app-custom-tab-list", {
                                    attrs: {
                                      section: "",
                                      "browse-name": _vm.browseName,
                                      "browse-id": _vm.browse.ID,
                                    },
                                  }),
                                  _c("app-custom-button-list", {
                                    attrs: {
                                      section: "",
                                      "browse-name": _vm.browseName,
                                      "browse-id": _vm.browse.ID,
                                    },
                                  }),
                                  _c("app-custom-report-button-list", {
                                    attrs: {
                                      section: "",
                                      "browse-name": _vm.browseName,
                                      "browse-id": _vm.browse.ID,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "5" } },
                    [
                      _vm.hasDefaultEditTabs
                        ? _c("app-default-edit-tab-list", {
                            attrs: {
                              "browse-name": _vm.browseName,
                              "browse-id": _vm.browse.ID,
                            },
                          })
                        : _vm._e(),
                      _c("app-search-settings-edit", {
                        attrs: { browse: _vm.browse },
                      }),
                      _vm.browse.ID == 7 || _vm.browse.ID == 17
                        ? _c("app-sale-row-extra-search-settings", {
                            attrs: { "is-purchase": _vm.browse.ID == 17 },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }